import { isNil, find, propEq, pick, isEmpty } from 'ramda';
import {
  getAllowHidingDestinationProcessInDigital,
  getMissions,
  getCarDestinations as getRecommendedCarDestinations
} from '../selectors/coreApi';
import { getCarDestination } from '../selectors/carDestination';
import { VEHICLE_DESINATION_TYPE, VEHICLE_DESINATION_REASON } from '../enums';
import { MISSION_LOADED, MISSION_PUTTED } from './coreApi';
import { lastMissionTow } from '../utils/coreApi';

export const SET_CAR_DESTINATIONS_VALUES = 'DRSA/CAR_DESTINATIONS/SET_CAR_DESTINATIONS_VALUES';

export const initialState = {};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CAR_DESTINATIONS_VALUES:
      return { ...action.payload };
    default:
      return state;
  }
};

export const storeData = ({ payload }) => ({ type: SET_CAR_DESTINATIONS_VALUES, payload });
export const storeCarDestinationInMission = () => (dispatch, getState) => {
  const state = getState();
  const recommendedCarDestinations = getRecommendedCarDestinations(state);
  const isDestinationProcessHidden = getAllowHidingDestinationProcessInDigital(state);
  let vehicleDestination = {
    type: VEHICLE_DESINATION_TYPE.NONE,
    reason: VEHICLE_DESINATION_REASON.NO_NETWORK_AVAILABLE,
  };
  if (!isEmpty(getCarDestination(state))) {
    vehicleDestination = getCarDestination(state);
  }
  if (isDestinationProcessHidden && !isEmpty(recommendedCarDestinations)) {
    vehicleDestination = { type: VEHICLE_DESINATION_TYPE.RECOMMENDED, id: recommendedCarDestinations[0].id };
  }
  const providerId = vehicleDestination?.id;
  const missionVehicleDestination = {
    vehicleDestination: !isNil(providerId)
      ? {
        type: VEHICLE_DESINATION_TYPE.RECOMMENDED,
        provider: { ...find(propEq('id', providerId), recommendedCarDestinations) },
      }
      : { type: vehicleDestination.type, provider: { ...pick(['name', 'location'], vehicleDestination) } },
  };

  dispatch({
    type: MISSION_PUTTED,
    mission: missionVehicleDestination,
  });
};

export const setTowMissionAsCurrentMission = () => (dispatch, getState) => {
  const state = getState();
  const missions = getMissions(state);
  const lastTowMission = lastMissionTow(missions);

  if (lastTowMission) {
    dispatch({
      type: MISSION_LOADED,
      mission: lastTowMission,
    });
  }
};

const actions = {
  storeData,
  storeCarDestinationInMission,
  setTowMissionAsCurrentMission,
};

export default { reducer, actions };
